module.exports = new __parcel__URL__("EPA_Super_Emitters_card.66a39579.png").toString();